import type { ReportsQueryScope } from '../../reports/domain/reportsQueryScope';
import { SALE_IS_ACTIVE, SALE_IS_ACTIVE_S } from './salesRepoSql';
import { buildAccentInsensitiveSqlExpression, normalizeSearchText } from '../../shared/format/searchText';
import type { SalesSnapshot, SalesSnapshotBase } from './salesSnapshotTypes';
import { fetchRemoteSalesSnapshot } from '../../reports/infra/reportsRemoteSalesKpiRepo';
export type { SalesSnapshot, SalesSnapshotBase } from './salesSnapshotTypes';

const EMPTY_SALES_SNAPSHOT: SalesSnapshot = {
  salesCount: 0,
  salesTotal: 0,
  fiscalSalesCount: 0,
  fiscalSalesTotal: 0,
  nonFiscalSalesCount: 0,
  nonFiscalSalesTotal: 0,
  pendingPayments: 0,
  pendingPaymentsAmount: 0,
  paymentBreakdown: [],
};

export const getTodaySalesSnapshot = async (branchId: string): Promise<SalesSnapshot> => {
  const todayStart = new Date();
  todayStart.setHours(0, 0, 0, 0);
  const todayIso = todayStart.toISOString();
  const endOfToday = new Date(todayStart);
  endOfToday.setHours(23, 59, 59, 999);
  return getSalesSnapshotByDateRange(branchId, todayIso, endOfToday.toISOString());
};

/** Ventas por rango de fechas (para selector Hoy / Ayer / Últimos 7 días) */
export const getSalesSnapshotByDateRange = async (
  branchId: string,
  fromIso: string,
  toIso: string
): Promise<SalesSnapshot> => {
  const remote = await fetchRemoteSalesSnapshot(branchId, fromIso, toIso);
        if (remote) return remote;
        return EMPTY_SALES_SNAPSHOT;
};

function ventasScopeHasLineFilters(scope: ReportsQueryScope): boolean {
  return (
    scope.itemType !== 'all' ||
    scope.categoryId != null ||
    (scope.productId?.trim() ?? '') !== '' ||
    (scope.search?.trim() ?? '') !== '' ||
    (scope.brandId?.trim() ?? '') !== '' ||
    (scope.supplierId?.trim() ?? '') !== ''
  );
}

function ventasScopeHasSaleLevelFilters(scope: ReportsQueryScope): boolean {
  return (
    (scope.cashierUserId?.trim() ?? '') !== '' ||
    (scope.customerId?.trim() ?? '') !== ''
  );
}

function cashierWhereClause(
  scope: ReportsQueryScope,
  alias = 's'
): { sql: string; params: string[] } {
  const id = scope.cashierUserId?.trim();
  if (!id) return { sql: '', params: [] };
  return { sql: ` AND ${alias}.cashier_user_id = ?`, params: [id] };
}

/**
 * Totales del período con filtros por ítem (offline), alineado con RPC de Supabase.
 */
export const getSalesSnapshotByDateRangeWithVentasScope = async (
  branchId: string,
  fromIso: string,
  toIso: string,
  scope: ReportsQueryScope
): Promise<SalesSnapshot> => {
  const remote = await fetchRemoteSalesSnapshot(branchId, fromIso, toIso, scope);
        if (remote) return remote;
        return EMPTY_SALES_SNAPSHOT;
};
